<template>
  <div class="popup__wrap on" v-if="medicalDevicePopFlag">
    <div class="medical_info_popup box__shadow__02">
      <div class="popup__top">
        <h4>&lt; 의료기기법에 의한 표시사항 &gt;</h4>
        <button class="pop__close__btn" @click="closeInfo()"></button>
        <p>본 제품은 <span class="red">'임상시험용 의료기기'</span>입니다.</p>
      </div>
      <ul class="info-contents vertical__scroll">
        <li>
          <div class="contents-wrap">
            <div class="title">품목명</div>
            <div class="contents">인지치료소프트웨어</div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">모델명</div>
            <div class="contents">{{ model }}</div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">사용목적</div>
            <div class="contents">
              {{ purpose }}
            </div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">제조사 및 제조업 허가번호</div>
            <div class="contents">(주)유비플러스 / 제 6694호</div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">제조사 주소</div>
            <div class="contents">
              <p>서울특별시 강남구 봉은사로57길 13, 4층(삼성동)</p>
            </div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">제조사 연락처</div>
            <div class="contents">TEL. 070-5001-6121 / FAX. 070-5001-6126</div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">부작용 보고 관련 문의처</div>
            <div class="contents">
              한국의료기기안전정보원 (TEL.080-080-4183)
            </div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">허가번호</div>
            <div class="contents">제허 XX-XXXX호</div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">사용방법 및 사용시 주의사항</div>
            <div class="contents">사용설명서 참조</div>
            <a :href="this.manualURL" target="_blank"
              ><img
                src="@/assets/images/icon/import_contacts.svg"
                class="book-icon"
            /></a>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">의료기기 표준코드(UDI)</div>
            <div class="contents">{{ UDICode }}</div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">제조번호(SW 버전정보)</div>
            <div class="contents">{{ serialNum }}</div>
          </div>
        </li>
        <li>
          <div class="contents-wrap">
            <div class="title">제조년월(SW 배포일자)</div>
            <div class="contents">{{ releaseDate }}</div>
          </div>
        </li>
        <!-- <div class="barcode">
          바코드
          <img />
        </div> -->
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: "A-STOP / U-AT-01",
      purpose:
        "알코올사용에 의한 정신 및 행동 장애 환자의 알코올사용 장애 증상을 치료하기 위해 동기강화치료 및 인지행동치료를 기반으로 한 치료 컨텐츠를 제공하는 소프트웨어(의료진용 웹과 환자용 어플리케이션으로 구성)",
      manualURL:
        "https://drive.google.com/file/d/1cWB8KWN7c1IKOpvg7KZguAEMNK4dU3QE/view",
      UDICode: "XXXXXXXXXXXXX",
      serialNum: "1.0.0",
      releaseDate: "YYYY.MM",
    };
  },
  props: {
    medicalDevicePopFlag: Boolean,
  },
  created() {
    this.getMindStrongInfo();
  },
  methods: {
    closeInfo() {
      this.$emit("closeInfo", false);
    },
    getMindStrongInfo() {
      // 마인드스트롱 의료기기법에 의한 표시사항
      const host = window.location.host;
      const hostArr = host.split(".");
      const location = hostArr[0];
      console.log("location", location);

      if (location === "mindstrong") {
        //
        this.model = "MIND STRONG / U-MS-01";
        this.purpose = `경도 인지장애 환자의 인지장애 증상을 개선하기 위해 인지중재치료 기반 콘텐츠를 제공하는 소프트웨어 (의료진용 웹과 환자용 어플리케이션으로 구성)`;
        this.manualURL =
          "https://drive.google.com/file/d/1KjXA5qDdGp5stl23fUYo5vzZPX5D8XPf/view?usp=sharing";
        this.UDICode = "XXXXXXXXXXXXX";
        this.serialNum = "X.X";
        this.releaseDate = "YYYY.MM";
      }
    },
  },
};
</script>
<style scoped>
.medical_info_popup {
  /* width: 30%; */
  width: clamp(400px, 30%, 500px);
  height: 80%;
  background-color: #f2f2f2;
  border-radius: 10px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 10px;
  box-sizing: border-box;
  font-size: 15px;
}

.popup__top {
  height: 10%;
}

.popup__top > h4 {
  font-size: 18px;
  width: 100%;
  text-align: center;
  padding: 0 0 15px;
  box-sizing: border-box;
}
.pop__close__btn {
  width: 20px;
  height: 20px;
  background-color: transparent;
  outline: none;
  border: none;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.pop__close__btn::before {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  background: #000;
  height: 70%;
  width: 2px;
  border-radius: 100px;
  display: block;
  content: "";
}

.pop__close__btn::after {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  background: #000;
  height: 70%;
  width: 2px;
  border-radius: 100px;
  display: block;
  content: "";
}

.red {
  color: red;
}

.info-contents {
  background-color: #fff;
  overflow: scroll;
  height: 90%;
  border-radius: 10px;
}

.info-contents::-webkit-scrollbar {
  background-color: transparent;
}

.info-contents > li {
  position: relative;
}

.book-icon {
  width: 35px;
  height: 35px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.info-contents > li:not(:last-child)::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #d2d2d2;
}

.contents-wrap {
  padding: 10px 15px;
  position: relative;
}

.contents-wrap > .title {
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 15px;
}

.contents-wrap > .contents {
  font-weight: 400;
  font-size: 14px;
}
</style>
